export default {
  path: '/school',
  name: 'school',
  redirect: '/school/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/school'),
      meta: { requiresAuth: true }
    },
  ]
}
